import fetchServer from "../../fetchServer";

/**
 * @param {string} accountId
 * @param {{ clientId: string, clientSecret: string }} param1
 */
export async function updateAdminAmadeusKey(
  accountId,
  { clientId, clientSecret },
) {
  let result = {
    return: 0,
    msg: "Something went wrong updating admin supplier keys!",
  };

  await fetchServer({
    method: "POST",
    url: `/product/v1/adminCustomKey/${accountId}/amadeus`,
    data: {
      clientId,
      clientSecret,
    },
  })
    .then((res) => {
      if (res?.data && !res?.data?.error) {
        result = { return: 1, msg: "Successful", data: res?.data?.data };
      } else if (res?.data?.error) result["msg"] = res.data.error;
    })
    .catch((err) => {
      console.log("Network Error!");
    });

  return result;
}

/**
 * @param {string} accountId
 * @param {{ username: string, password: string, targetBranch: string }} param1
 */
export async function updateAdminTravelportKey(
  accountId,
  { username, password, targetBranch },
) {
  let result = {
    return: 0,
    msg: "Something went wrong updating admin supplier keys!",
  };

  await fetchServer({
    method: "POST",
    url: `/product/v1/adminCustomKey/${accountId}/travelport`,
    data: {
      username,
      password,
      targetBranch,
    },
  })
    .then((res) => {
      if (res?.data && !res?.data?.error) {
        result = { return: 1, msg: "Successful", data: res?.data?.data };
      } else if (res?.data?.error) result["msg"] = res.data.error;
    })
    .catch((err) => {
      console.log("Network Error!");
    });

  return result;
}

/**
 * @param {string} accountId
 * @param {{ userId: string, password: string, clientId: string, clientSecret: string }} param1
 */
export async function updateAdminSabreKey(
  accountId,
  { userId, password, clientId, clientSecret },
) {
  let result = {
    return: 0,
    msg: "Something went wrong updating admin supplier keys!",
  };

  await fetchServer({
    method: "POST",
    url: `/product/v1/adminCustomKey/${accountId}/sabre`,
    data: {
      userId,
      password,
      clientId,
      clientSecret,
    },
  })
    .then((res) => {
      if (res?.data && !res?.data?.error) {
        result = { return: 1, msg: "Successful", data: res?.data?.data };
      } else if (res?.data?.error) result["msg"] = res.data.error;
    })
    .catch((err) => {
      console.log("Network Error!");
    });

  return result;
}

/**
 * @param {string} accountId
 * @param {{
 *   username: string,
 *   password: string,
 *   officeId: string,
 *   dutyCode: string,
 *   wsap: string,
 *   wsdlFileName?: string,
 *   _files?: File[],
 * }} data
 */
export async function updateAdminAmadeusSoapKey(accountId, data) {
  let result = {
    return: 0,
    msg: "Something went wrong updating admin supplier keys!",
  };

  const {
    username,
    password,
    officeId,
    dutyCode,
    wsap,
    wsdlFileName,
    _files,
  } = data || {};

  const formData = new FormData();
  formData.append("username", username ?? "");
  formData.append("password", password ?? "");
  formData.append("officeId", officeId ?? "");
  formData.append("dutyCode", dutyCode ?? "");
  formData.append("wsap", wsap ?? "");

  const wsdlFile = Array.isArray(_files) ? _files[0] : null;

  let wsdlFileNameValue = wsdlFileName ?? "";
  if (wsdlFileNameValue && !String(wsdlFileNameValue).endsWith(".wsdl")) {
    wsdlFileNameValue = `${wsdlFileNameValue}.wsdl`;
  }
  if (wsdlFileNameValue) {
    formData.append("wsdlFileName", wsdlFileNameValue);
  }

  if (wsdlFile instanceof File) {
    formData.append("wsdlFile", wsdlFile, wsdlFile.name);
  } else if (wsdlFile instanceof Blob) {
    formData.append("wsdlFile", wsdlFile, "upload.zip");
  }

  await fetchServer({
    method: "POST",
    url: `/product/v1/adminCustomKey/${accountId}/amadeusSoap`,
    data: formData,
  })
    .then((res) => {
      if (!res || res.cancelled) return;

      if (res?.status >= 200 && res?.status < 300 && res?.data) {
        if (!res.data.error) {
          result = {
            return: 1,
            msg: res.data.message || "Successful",
            data: res.data.data,
          };
        } else {
          result.msg = res.data.error;
        }
        return;
      }

      const errBody = res?.data ?? res;
      if (errBody?.error) result.msg = errBody.error;
      else if (errBody?.message) result.msg = errBody.message;
    })
    .catch((err) => {
      console.log("Network Error!");
    });

  return result;
}
